import {postRequest} from "../utils/fetch";

const basePath = "/api/v1/OrderService.svc/json/";
export interface IBaseOrderRequest {
	language: string;
	pointOfSaleId: string;
}

export interface IPriceRequest extends IBaseOrderRequest {
	pvc: string;
	quantity: number;
	variableAmount: number;
	options: string[];
	promoCode: string | undefined;
	forceQuantityBreak: number;
}

export interface ICurrency {
	CurrencyCode: string;
	CurrencySymbol: string;
	DisplayLeftToPrice: boolean;
	DecimalSeparator: string;
}

export interface IPrice {
	Currency: ICurrency;
	Amount: number;
}

export interface IPriceDetails {
	Price: IPrice;
	PriceItems: IPriceItem[];
}

export interface IPriceItem {
	Description: string;
	CalculationDescription: string;
	ItemTotal: string;
	Type: string;
}

export function getPrice (
	pvc: string,
	quantity: number,
	variableAmount = 0,
	options: string[] = [],
	promoCode: string | undefined = undefined,
	forceQuantityBreak = -1): Promise<IPriceDetails> {
	const request: IPriceRequest = {
		pointOfSaleId: window.context.pointOfSaleId,
		language: window.context.language,
		pvc,
		quantity,
		variableAmount,
		options,
		promoCode: promoCode === undefined ? '' : promoCode,
		forceQuantityBreak
	};
	return postRequest<IPriceRequest, { GetPriceResult: IPriceDetails }>(
		basePath + "GetPrice",
		request,
		{ headers: new Headers({'Content-type': 'application/json; charset=utf-8'}) })
		.then(res => {
			return res.GetPriceResult;
		}) as Promise<IPriceDetails>;
}
